import axios from 'axios';
import Vue from 'vue'

export default {
    cartToOrder(newOrderRequest) {        
        return axios.post('/api/orders/cart-to-order', newOrderRequest,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        )
        .then(response => {
            if (response && response.data) return response.data;
        })
         .catch(error => {
            Vue.prototype.$snotify.error(error);
            return Promise.reject(error);
        })
    },

    getOrderBySpecialRef(specialRef) {        
        return axios.get('/api/orders/get/special-ref', {params : {specialRef:specialRef}})
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    getOrderByPaymentRef(paymentRef) {        
        return axios.get('/api/orders/get/payment-ref', {params : {paymentRef:paymentRef}})
        .then(response => {
            if (response && response.data) return response.data;
        })
    },


 getOrders(orderRequest) {

        return axios.get('/api/orders/customer/list', { params: {
            page: orderRequest.page,
            pageSize: orderRequest.perPage,
            showDrafts: orderRequest.showDrafts,
            exchangeOrders: orderRequest.exchangeOrders,
            deliveryNoteId:orderRequest.deliveryNote,
            status:orderRequest.status ? orderRequest.status.join(",") : null,
            pointingState:orderRequest.pointingState,
            customerId:orderRequest.customerId,
            customerName:orderRequest.customerName,
            start:orderRequest.start,
            end:orderRequest.end,
            current:orderRequest.current,
            showUnsynchronisedOrders:orderRequest.showUnsynchronisedOrders,
            channel:orderRequest.channel,
            deliveryModeId:orderRequest.deliveryModeId,
            phoneNumber:orderRequest.phoneNumber,
            bcNumber:orderRequest.bcNumber,
            countryId:orderRequest.countryId,
            cityId:orderRequest.cityId,
            orderNumber:orderRequest.orderNumber,
            selectedPaymentMethode: orderRequest.selectedPaymentMethode,
            itemRef: orderRequest.itemRef,
            exportOrderLine: orderRequest.isLinesFormat,
            } })

        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersExport(orderRequest){
        return axios({
            url:'/api/orders/customer/list',
            params: {
                page: orderRequest.page,
                pageSize: orderRequest.perPage,
                showDrafts: orderRequest.showDrafts,
                status:orderRequest.status ? orderRequest.status.join(",") : null,
                pointingState:orderRequest.pointingState,
                customerId:orderRequest.customerId,
                customerName:orderRequest.customerName,
                start:orderRequest.start,
                end:orderRequest.end,
                current:orderRequest.current,
                showUnsynchronisedOrders:orderRequest.showUnsynchronisedOrders,
                channel:orderRequest.channel,
                deliveryModeId:orderRequest.deliveryModeId,
                phoneNumber:orderRequest.phoneNumber,
                bcNumber:orderRequest.bcNumber,
                countryId:orderRequest.countryId,
                cityId:orderRequest.cityId,
                orderNumber:orderRequest.orderNumber,
                selectedPaymentMethode: orderRequest.selectedPaymentMethode,
                itemRef: orderRequest.itemRef,
                exportOrderLine: orderRequest.isLinesFormat,
                },
            method: 'GET',
            responseType: 'blob ,application/json, text/plain ',
            headers: {'Accept': 'Text/CSV'},
                }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');    
                const href = window.URL.createObjectURL(blob);  
                aEle.href = href;
                aEle.download = response.headers["filename"]; 
                document.body.appendChild(aEle);
                aEle.click();     
                document.body.removeChild(aEle); 
                window.URL.revokeObjectURL(href) 
                
          }).catch(error => {Vue.prototype.$snotify.error(error);})   ;
    },

    getOrder (orderId) {
        return axios.get('/api/orders/order', { params: { orderId: orderId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getOrdersByCustomer (page, pageSize,supplierId, onlyDrafts,status,current,start,end, channel , itemTitle , orderRef) {
        return axios.get('/api/orders/customer/list', { params: { page: page, pageSize: pageSize,supplierId:supplierId, showDrafts: onlyDrafts, status : status,current:current, start:start,end:end, channel:channel , itemTitle:itemTitle ,orderRef:orderRef} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getCustomerDeliveryAddresses () {
        return axios.get('/api/orders/customer/deliveryAdresses')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getDeliveryModes () {
        return axios.get('/api/orders/deliveryModes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getOrdersCount(status){
        return axios.get('/api/orders/count/',{ params: { status:status} })
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {console.log(error);})
    },
}

